/**
 * The colours the household's members wear. The module's own copy, so it imports
 * nothing from another module (the independence rule) — the values match the
 * agenda and todo palettes on purpose, so a person reads as the same colour
 * everywhere. Colour is never the only cue; the name always sits beside the dot.
 */
const MEMBER_PALETTE = ['#2563eb', '#ea7317', '#7a5cd0', '#2e9e8f'] as const;

export function memberColor(userId: string | null, memberIds: string[]): string | null {
  if (!userId) return null;
  const i = memberIds.indexOf(userId);
  return MEMBER_PALETTE[(i >= 0 ? i : 0) % MEMBER_PALETTE.length]!;
}
